import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import { cn } from "@/lib/utils";
import { ArrowRight, Search } from "lucide-react";
import { GlassBlockHeader } from "../GlassBlockHeader";
import { AcademicCapIcon } from "../HomeIcons";
import { GLASS_BLOCK_CLASS, type GlassTheme } from "../glass";

/** Bloc « Mes tutoriels » : accès à la liste et à la recherche. */
export const TutorialsBlock = ({
  theme,
  onOpenList,
  onSearch,
}: {
  theme: GlassTheme;
  onOpenList: () => void;
  onSearch: () => void;
}) => {
  const vt = useVisibleT();
  // Même pastille que les raccourcis, collée sous le titre : les boutons
  // démarrent à la hauteur de la première ligne du bloc Raccourcis.
  const pillClass =
    "group flex w-full items-center gap-2.5 rounded-full border-[0.5px] border-white bg-white/70 px-4 py-2.5 text-sm font-medium text-slate-900 backdrop-blur-[25px] transition-colors hover:bg-white";
  return (
    <section
      className={cn(GLASS_BLOCK_CLASS, "flex flex-1 flex-col gap-4 p-4")}
      style={theme.surface}
    >
      <GlassBlockHeader
        theme={theme}
        icon={<AcademicCapIcon />}
        title={vt("bo.home.tutorials.title", "Mes tutoriels")}
      />
      <div className="flex flex-col gap-2.5">
        <button type="button" onClick={onOpenList} className={pillClass}>
          <span className="min-w-0 flex-1 text-left">
            {vt("bo.home.tutorials.seeAll", "Voir la liste des tutoriels")}
          </span>
          <ArrowRight
            className="size-4 shrink-0 transition-transform group-hover:translate-x-0.5"
            aria-hidden
          />
        </button>
        <button type="button" onClick={onSearch} className={pillClass}>
          <Search className="size-4 shrink-0" aria-hidden />
          <span className="min-w-0 flex-1 text-left">
            {vt("bo.home.tutorials.search", "Rechercher un tutoriel")}
          </span>
        </button>
      </div>
    </section>
  );
};
